const ammonite = {
  title: "암모나이트를 만나다",
  subtitle: "AR, VR & Holographic Display",
  about:
    "암모나이트를 만나다는 3O(Offline-Onsite-Online) 프레임워크를 기반으로 한 체험형 전시입니다. 3O는 하나의 주제로부터 박물관의 공간을 차지하는 전시(Offline), 박물관의 물리적 공간을 활용하나 AR 기술을 활용하여 새롭게 증강된 현실에서 진행되는 전시(Onsite), VR 기술을 활용하여 박물관 외 공간에서 자유롭게 체험할 수 있는 전시(Online)와 같이 다양한 플랫폼의 전시가 파생된 형태를 의미합니다.\n" +
    "동일한 리소스로부터 여러 종류의 전시를 개발할 수 있어 시간과 비용 측면에서 효율적이며, 동일한 주제를 다양한 방식으로 다양한 공간에서 체험할 수 있도록 하여 정보 전달 효과를 향상시킬 수 있습니다.이를 통해서 다양한 설치 환경에서도 SketchScope가 작동할 수 있게 됩니다.\n",
  paperlink: "https://www.dbpia.co.kr/pdf/pdfView.do?nodeId=NODE11229719",
  arhd:
    "박물관의 전시 환경을 그대로 이용하되, 체험적 요소를 가미한 새로운 전시를 증강하여 효과적으로 심화된 정보를 전달할 수 있습니다. 관람객이 AR 전시 체험을 통해 생성한 작품은 박물관에 놓인 홀로그래픽 디스플레이에 나타나 현장 전시에 반영됩니다. 이를 통해 관람객은 즐겁게 전시를 체험하는 소비자가 될 뿐만 아니라, 능동적으로 전시에 영향을 주는 생산자의 역할을 하게 됩니다\n",
  vr:
    "시간, 공간의 제약으로 박물관에 직접 방문할 수 없는 경우에도 동일한 전시 컨텐츠를 즐길 수 있습니다. VR 장비를 착용하면 실제 박물관과 동일하게 구성된 공간으로 이동하게 되는데요. 관람객은 박물관과 바닷속을 이동하며 전시물에 관한 자세한 정보를 얻고, 전시물과 능동적으로 상호작용하는 경험을 할 수 있습니다.",
  updates:
    "Leap Motion에서 Motion Recognition이 어떻게 이뤄졌는지 확인할 수 있습니다. \n" +
    "자세한 사항은 아래 데모 영상을 참고해 주세요.\n",
  demo_videos: [
    "@/assets/암모나이트를 만나다.mp4",
    "@/assets/암모나이트를 만나다 Demo.mp4",
    "@/assets/VR_demo.mp4",
  ],
};

export { ammonite };
